import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setDataTableFilters } from '../../redux/actions'
import { RootState } from '../../redux/types'
import { UncheckedOptionIdsByFilterId } from '../utils/tableFilters'

export type DataTableScope = {
    id: string
    keptPer: 'user' | 'organization' | 'roadmap'
}

const ANY = 'any'

const NOTHING_UNCHECKED: UncheckedOptionIdsByFilterId = {}

const getDataTableFiltersKey = (state: RootState, scope: DataTableScope) => {
    const userId = state.userRecord?._id
    const organizationId = scope.keptPer === 'user' ? ANY : state.userRecord?.organizationId
    const roadmapId = scope.keptPer === 'roadmap' ? state.strategy?._id : ANY

    if (!userId || !organizationId || !roadmapId) return null

    return [userId, organizationId, roadmapId, scope.id].join('/')
}

export const useDataTableFiltersStorage = (scope: DataTableScope) => {
    const dispatch = useDispatch()

    const storageKey = useSelector((state: RootState) => getDataTableFiltersKey(state, scope))

    const stored = useSelector((state: RootState) => (storageKey ? state.dataTableFilters?.[storageKey] : undefined))

    const setUnchecked = useCallback(
        (uncheckedByFilterId: UncheckedOptionIdsByFilterId) => {
            if (!storageKey) return

            dispatch(setDataTableFilters({ storageKey, uncheckedByFilterId }))
        },
        [dispatch, storageKey]
    )

    return { unchecked: stored ?? NOTHING_UNCHECKED, setUnchecked }
}
